import { GetFragmentDto, Station } from '@mi-front/core';
import { Box } from '@mui/material';
import { ExternalExportStatus } from './external-export/ExternalExportStatus';
import { FragmentSocialPublishView } from './FragmentSocialPublishView';

interface Props {
  readonly station: Station;
  readonly fragment: GetFragmentDto;
}

/**
 * Export "Publish" tab content: social platforms and external export.
 */
export const FragmentPublishView = ({ station, fragment }: Props) => {
  return (
    <Box sx={{ maxWidth: 'md' }}>
      <FragmentSocialPublishView station={station} fragment={fragment} />
      <Box mt={4}>{fragment.media.status === 'READY' ? <ExternalExportStatus /> : null}</Box>
    </Box>
  );
};
